export const ohio = {
  "39000": "Ohio",
  "39001": "Adams County",
  "39003": "Allen County",
  "39005": "Ashland County",
  "39007": "Ashtabula County",
  "39009": "Athens County",
  "39011": "Auglaize County",
  "39013": "Belmont County",
  "39015": "Brown County",
  "39017": "Butler County",
  "39019": "Carroll County",
  "39021": "Champaign County",
  "39023": "Clark County",
  "39025": "Clermont County",
  "39027": "Clinton County",
  "39029": "Columbiana County",
  "39031": "Coshocton County",
  "39033": "Crawford County",
  "39035": "Cuyahoga County",
  "39037": "Darke County",
  "39039": "Defiance County",
  "39041": "Delaware County",
  "39043": "Erie County",
  "39045": "Fairfield County",
  "39047": "Fayette County",
  "39049": "Franklin County",
  "39051": "Fulton County",
  "39053": "Gallia County",
  "39055": "Geauga County",
  "39057": "Greene County",
  "39059": "Guernsey County",
  "39061": "Hamilton County",
  "39063": "Hancock County",
  "39065": "Hardin County",
  "39067": "Harrison County",
  "39069": "Henry County",
  "39071": "Highland County",
  "39073": "Hocking County",
  "39075": "Holmes County",
  "39077": "Huron County",
  "39079": "Jackson County",
  "39081": "Jefferson County",
  "39083": "Knox County",
  "39085": "Lake County",
  "39087": "Lawrence County",
  "39089": "Licking County",
  "39091": "Logan County",
  "39093": "Lorain County",
  "39095": "Lucas County",
  "39097": "Madison County",
  "39099": "Mahoning County",
  "39101": "Marion County",
  "39103": "Medina County",
  "39105": "Meigs County",
  "39107": "Mercer County",
  "39109": "Miami County",
  "39111": "Monroe County",
  "39113": "Montgomery County",
  "39115": "Morgan County",
  "39117": "Morrow County",
  "39119": "Muskingum County",
  "39121": "Noble County",
  "39123": "Ottawa County",
  "39125": "Paulding County",
  "39127": "Perry County",
  "39129": "Pickaway County",
  "39131": "Pike County",
  "39133": "Portage County",
  "39135": "Preble County",
  "39137": "Putnam County",
  "39139": "Richland County",
  "39141": "Ross County",
  "39143": "Sandusky County",
  "39145": "Scioto County",
  "39147": "Seneca County",
  "39149": "Shelby County",
  "39151": "Stark County",
  "39153": "Summit County",
  "39155": "Trumbull County",
  "39157": "Tuscarawas County",
  "39159": "Union County",
  "39161": "Van Wert County",
  "39163": "Vinton County",
  "39165": "Warren County",
  "39167": "Washington County",
  "39169": "Wayne County",
  "39171": "Williams County",
  "39173": "Wood County",
  "39175": "Wyandot County",
};
